import { supabase } from '../lib/supabase';

export const submitProject = async (formData) => {
  try {
    const { short_description, github_url, demo_url, additional_files, team_id } = formData;

    // Create project
    const { data, error } = await supabase
      .from('projects')
      .insert([{
        short_description,
        github_url,
        demo_url,
        additional_files: additional_files || null,
        submitted: true,
        team_id: team_id // Link project to the team
      }])
      .select()
      .single();

    if (error) {
      throw error;
    }

    return {
      success: true,
      message: 'تم تقديم المشروع بنجاح!',
      data
    };
  } catch (err) {
    console.error('Error submitting project:', err);
    return {
      success: false,
      message: 'حدث خطأ أثناء تقديم المشروع. يرجى المحاولة مرة أخرى.'
    };
  }
};

export const getAllProjects = async () => {
  try {
    let query = supabase
      .from('projects')
      .select(`
        *,
        team:teams!projects_team_id_fkey(
          team_name,
          leader:applicants!teams_leader_id_fkey(full_name, email)
        )
      `)
      .order('created_at', { ascending: false });

    const { data, error } = await query;

    if (error) {
      throw error;
    }

    return {
      success: true,
      data: data || []
    };
  } catch (err) {
    console.error('Error fetching projects:', err);
    return {
      success: false,
      message: 'حدث خطأ أثناء جلب بيانات المشاريع',
      data: []
    };
  }
};

export const updateProject = async (projectId, updates) => {
  try {
    const { data, error } = await supabase
      .from('projects')
      .update(updates)
      .eq('id', projectId)
      .select()
      .single();

    if (error) {
      throw error;
    }

    return {
      success: true,
      message: 'تم تحديث المشروع بنجاح',
      data
    };
  } catch (err) {
    console.error('Error updating project:', err);
    return {
      success: false,
      message: 'حدث خطأ أثناء تحديث المشروع'
    };
  }
};

export const deleteProject = async (projectId) => {
  try {
    const { error } = await supabase
      .from('projects')
      .delete()
      .eq('id', projectId);

    if (error) {
      throw error;
    }

    return {
      success: true,
      message: 'تم حذف المشروع بنجاح'
    };
  } catch (err) {
    console.error('Error deleting project:', err);
    return {
      success: false,
      message: 'حدث خطأ أثناء حذف المشروع'
    };
  }
};

export const getProjectStats = async () => {
  try {
    const { data, error } = await supabase
      .from('projects')
      .select('submitted, created_at');

    if (error) {
      throw error;
    }

    const stats = {
      total: data.length,
      submitted: data.filter(p => p.submitted).length,
      notSubmitted: data.filter(p => !p.submitted).length
    };

    return {
      success: true,
      data: stats
    };
  } catch (err) {
    console.error('Error fetching project stats:', err);
    return {
      success: false,
      message: 'حدث خطأ أثناء جلب إحصائيات المشاريع',
      data: null
    };
  }
};
